import Vector2 from '@/models/Vector2'

export default function CalculateTextSize(text : string, size : number = 30, family : string = "") : Vector2
{
	let div = (document.getElementById("text-size-test-element") as HTMLDivElement);
	div.style.fontSize = size.toString();
	div.style.fontFamily = family;
	div.innerText = text;
	return new Vector2(div.clientWidth, div.clientHeight);
}

// TODO: this returns nothing but 0... not sure if it needs to wait for nextTick or something...
export function CalculateNodeTextSize(text : string) : Vector2
{
	let div = (document.getElementById("node-text-size-test-element") as HTMLDivElement);
	div.innerText = text;
	return new Vector2(div.clientWidth, div.clientHeight);
}

(window as any).CalculateTextSize = CalculateTextSize;